module.exports = __webpack_public_path__ + "img/z-1.6495a124.png";